import React from 'react'
import { Button } from 'react-bootstrap'

const CityMultiSelect = ({ citys, selectedCitys, handleButtonClick }) => {
  return (
    <div className="text-center p-3">
      {citys.map((city) => {
        const buttonClass = `btn btn-city ${
          selectedCitys.includes(city.name) ? 'selected' : 'unselected'
        }`

        return (
          <Button
            key={city.name}
            onClick={() => handleButtonClick(city.name)}
            className={buttonClass}
            variant=""
          >
            {city.name}
          </Button>
        )
      })}
    </div>
  )
}

export default CityMultiSelect
